import {ls} from "@/CultureService";

export function translateTrueFalse(value: boolean): string {
    return value ? ls.Global_Text_Yes : ls.Global_Text_No;
}

export function translateTrueFalseEst(value: boolean): string {
    return value ? "Jah" : "Ei";
}

export function translateTrueFalseEng(value: boolean): string {
    return value ? "Yes" : "No";
}